import elephantLogoImg from '../assets/elephantLogo.png';

interface LogoMarkProps {
	className?: string;
	size?: number | string;
	monochrome?: boolean;
}

export function ElephantLogoMark({ className = 'w-11 h-11', size, monochrome = false }: LogoMarkProps) {
	return (
		<img
			src={elephantLogoImg}
			alt='Elephant Expeditions Mark'
			className={`object-contain ${className} ${monochrome ? 'brightness-0 invert' : ''}`}
			style={size ? { width: size, height: size } : undefined}
			referrerPolicy='no-referrer'
		/>
	);
}

interface LogoProps {
	isHeaderTransparent?: boolean;
	variant?: 'light' | 'dark' | string;
	size?: 'sm' | 'md' | 'lg' | string;
	onClick?: () => void;
}

/**
 * Complete Elephant Expeditions Brand Logo Lockup
 * Renders the Elephant mark with precisely justified 3-line typography
 * (ELEPHANT, EXPEDITIONS, NEVER FORGET)
 */
export function ElephantLogo({ isHeaderTransparent, variant, size, onClick }: LogoProps) {
	const isLight = isHeaderTransparent || variant === 'dark';
	const markSizeClass = size === 'sm' ? 'w-9 h-9' : size === 'lg' ? 'w-14 h-14' : 'w-12 h-12';
	const titleSizeClass = size === 'sm' ? 'text-lg' : size === 'lg' ? 'text-2xl' : 'text-xl';
	const tagSizeClass = size === 'sm' ? 'text-[8px]' : size === 'lg' ? 'text-[10px]' : 'text-[9px]';

	return (
		<div id='layout-logo' className='flex items-center space-x-3 cursor-pointer group' onClick={onClick}>
			<div className='flex items-center justify-center'>
				<img
					src={elephantLogoImg}
					alt='Elephant Expeditions Mark'
					className={`object-contain ${markSizeClass}`}
					style={size ? { width: size, height: size } : undefined}
					referrerPolicy='no-referrer'
				/>
			</div>

			{/* Text container: w-fit ensures the container width matches the longest line (Expeditions) */}
			<div className='flex flex-col w-fit text-left'>
				{/* Line 1: ELEPHANT stretched */}
				<div
					className={`flex justify-between uppercase font-serif ${titleSizeClass} font-semibold leading-none transition-colors duration-300 ${
						isLight ? 'text-white' : 'text-brand-forest'
					}`}
				>
					{'ELEPHANT'.split('').map((char, i) => (
						<span key={i}>{char}</span>
					))}
				</div>

				{/* Line 2: Expeditions (The natural widest element that sets the boundary) */}
				<div
					className={`uppercase font-serif ${titleSizeClass} font-semibold leading-none mt-0.5 tracking-wider transition-colors duration-300 ${
						isLight ? 'text-white' : 'text-brand-forest'
					}`}
				>
					Expeditions
				</div>

				{/* Line 3: Never Forget (Flex space-between for word + letter balance, lined up left and right) */}
				<div
					className={`flex justify-between uppercase font-sans ${tagSizeClass} font-semibold mt-1 transition-colors duration-300 ${
						isLight ? 'text-brand-gold-light' : 'text-brand-gold-dark'
					}`}
				>
					{'NEVER FORGET'.split('').map((char, i) => (
						<span key={i}>{char === ' ' ? '\u00A0' : char}</span>
					))}
				</div>
			</div>
		</div>
	);
}

export default ElephantLogo;
